$shm_projects_task $mol_book2
	project_id \
	task_id \
	pages <= task_pages /
	Details_page $mol_page
		title_content <= task_title_rows /
		body <= task_body /
	Task_title $mol_string_button
		value? <=> task_title_draft? \
		submit? <=> task_title_commit? null
		event *
			^
			blur? <=> task_title_commit? null
			keydown? <=> task_title_keydown? null
	Description_draft $shm_projects_goal_request
		label \Описание задачи
		requirements true
		value? <=> description_draft? \
		after /
			<= Send_agent $mol_button_major
				title \Отправить агенту
				enabled <= send_agent_enabled true
				click? <=> send_agent? null
	Description_card $mol_view
		sub /
			<= Description_title $mol_view
				sub / \Описание задачи
			<= Description_text $mol_text
				text <= task_description \
	Agent $shm_projects_task_chat
		run <= run_data? null
		iteration <= task_iteration 0
		version <= project_version \
		workspace_id <= workspace_id \base
		prompt? <=> message_draft? \
		send? <=> send_message? null
		after <= agent_after /
	Result_card $mol_view
		sub /
			<= Result_title $mol_view
				sub / \Результаты
			<= Result_text $shm_hitalama_text
				text <= task_result \
